import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext({});

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

const translations = {
  it: {
    // Navigation
    home: 'Home',
    categories: 'Categorie',
    requests: 'Richieste',
    dashboard: 'Dashboard',
    profile: 'Profilo',
    logout: 'Esci',
    login: 'Accedi',
    signup: 'Registrati',
    
    // Home
    hero_title: 'Stand Out, Hand Made.',
    hero_subtitle: 'Scopri creazioni artigianali uniche da Milano al mondo',
    browse_crafters: 'Esplora Artigiani',
    post_request: 'Pubblica Richiesta',
    featured_crafters: 'Artigiani in Evidenza',
    
    // Categories
    all_categories: 'Tutte le Categorie',
    filter_by: 'Filtra per',
    
    // Requests
    open_requests: 'Richieste Aperte',
    create_request: 'Crea Richiesta',
    my_requests: 'Le Mie Richieste',
    price_range: 'Fascia di Prezzo',
    timeline: 'Tempi',
    submit_proposal: 'Invia Proposta',
    
    // Dashboard
    my_dashboard: 'La Mia Dashboard',
    my_storefront: 'La Mia Vetrina',
    my_products: 'I Miei Prodotti',
    my_portfolio: 'Il Mio Portfolio',
    requests_for_you: 'Richieste per Te',
    tier_status: 'Stato Abbonamento',
    
    // Auth
    email: 'Email',
    password: 'Password',
    full_name: 'Nome Completo',
    role: 'Ruolo',
    client: 'Cliente',
    crafter: 'Artigiano',
    sign_in_with_google: 'Accedi con Google',
    
    // Tiers
    free: 'Gratuito',
    premium: 'Premium',
    pro: 'Pro',
    upgrade: 'Aggiorna',
  },
  en: {
    // Navigation
    home: 'Home',
    categories: 'Categories',
    requests: 'Requests',
    dashboard: 'Dashboard',
    profile: 'Profile',
    logout: 'Logout',
    login: 'Login',
    signup: 'Sign Up',
    
    // Home
    hero_title: 'Stand Out, Hand Made.',
    hero_subtitle: 'Discover unique handcrafted creations from Milan to the world',
    browse_crafters: 'Browse Crafters',
    post_request: 'Post Request',
    featured_crafters: 'Featured Crafters',
    
    // Categories
    all_categories: 'All Categories',
    filter_by: 'Filter by',
    
    // Requests
    open_requests: 'Open Requests',
    create_request: 'Create Request',
    my_requests: 'My Requests',
    price_range: 'Price Range',
    timeline: 'Timeline',
    submit_proposal: 'Submit Proposal',
    
    // Dashboard
    my_dashboard: 'My Dashboard',
    my_storefront: 'My Storefront',
    my_products: 'My Products',
    my_portfolio: 'My Portfolio',
    requests_for_you: 'Requests for You',
    tier_status: 'Tier Status',
    
    // Auth
    email: 'Email',
    password: 'Password',
    full_name: 'Full Name',
    role: 'Role',
    client: 'Client',
    crafter: 'Crafter',
    sign_in_with_google: 'Sign in with Google',
    
    // Tiers
    free: 'Free',
    premium: 'Premium',
    pro: 'Pro',
    upgrade: 'Upgrade',
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const value = {
    language,
    setLanguage,
    t,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
